import React from 'react';
import { Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import intl from 'react-intl-universal';

const ButtonBack = () => {
  const navigate = useNavigate();

  return (
    <Button outline className="btn alternate back" onClick={() => navigate(-1)}>
      {intl.get('voltar')}
    </Button>
  );
};

export default ButtonBack;
